import { countryCodeMap } from "./countryCodeMap";

// Resolves country names at runtime via Intl.DisplayNames instead of
// hand-maintaining a second 195-row name list — every evergreen browser
// supports it, and it falls back to just the ISO code if unavailable.
let cachedRegionNames = null;
function getRegionDisplayNames() {
  if (cachedRegionNames !== null) return cachedRegionNames;
  try {
    cachedRegionNames = new Intl.DisplayNames(["en"], { type: "region" });
  } catch (e) {
    cachedRegionNames = false;
  }
  return cachedRegionNames;
}

function getCountryName(iso2) {
  const regionNames = getRegionDisplayNames();
  if (regionNames) {
    try {
      return regionNames.of(iso2) || iso2;
    } catch (e) {
      return iso2;
    }
  }
  return iso2;
}

// Sorted, display-ready list: [{ iso2, name, dialCode }, ...]
let cachedOptions = null;
export function getCountryOptions() {
  if (cachedOptions) return cachedOptions;
  cachedOptions = Object.keys(countryCodeMap)
    .map((iso2) => ({
      iso2,
      name: getCountryName(iso2),
      dialCode: countryCodeMap[iso2],
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return cachedOptions;
}